export type ErrorType = "api" | "client" | "network";

// TODO: Setup logging tool

export const logError = async (errorType: ErrorType, errorData: unknown) => {
  try {
    console.error(errorType, errorData);
  } catch (err) {
    console.error("Failed to process error", err);
  }
};
